var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"color":'info',"label":'',"icon":'mdi-refresh',"iconSize":24},on:{"click":_vm.onButtonClick}})}
var staticRenderFns = []

export { render, staticRenderFns }